import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicesShowcase.css';

const ServicesShowcase = () => {
  const navigate = useNavigate();

  return (
    <section className="services-showcase" data-testid="services-showcase">
      <div className="ss-container">
        <div className="ss-header">
          <div className="ss-badge">POWERED BY THE RIGHT 6&#8482; FRAMEWORK</div>
          <h2 className="ss-title">Our Services</h2>
          <p className="ss-subtitle">Two integrated solution lines — one strategic partner.</p>
        </div>

        <div className="ss-grid">
          {/* Consulting Solutions */}
          <div className="ss-card ss-card-light" data-testid="ss-consulting">
            <div className="ss-card-label">Consulting Solutions</div>
            <h3 className="ss-card-title">Strategic Leadership, Talent & Organizational Advisory</h3>
            <p className="ss-card-desc">
              Practical, senior-level support that strengthens leadership, talent infrastructure, governance, and people strategy.
            </p>
            <div className="ss-card-pillars">
              <div className="ss-pillar"><span>01</span> Leadership Development & Coaching</div>
              <div className="ss-pillar"><span>02</span> Talent Infrastructure</div>
              <div className="ss-pillar"><span>03</span> Governance Support</div>
            </div>
            <button className="ss-btn ss-btn-navy" onClick={() => navigate('/consulting-solutions')}>
              Explore Consulting Solutions
            </button>
          </div>

          {/* The Right Path */}
          <div className="ss-card ss-card-dark" data-testid="ss-rightpath">
            <div className="ss-card-label light">The Right Path</div>
            <h3 className="ss-card-title light">Strategic Workforce Development Program</h3>
            <p className="ss-card-desc light">
              A structured program that helps organizations assess talent needs, design pathways, launch training, and optimize workforce outcomes.
            </p>
            <div className="ss-card-pillars dark">
              <div className="ss-pillar dark"><span>01</span> Assessment & Roadmap</div>
              <div className="ss-pillar dark"><span>02</span> Pathway Design & Delivery</div>
              <div className="ss-pillar dark"><span>03</span> 77+ Workforce Offerings</div>
            </div>
            <button className="ss-btn ss-btn-gold" onClick={() => navigate('/the-right-path')}>
              Explore The Right Path
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesShowcase;
